require('./app');
require('jquery-mask-plugin');
require('./components/notifications');
require('./pages/postJob');
require('./pages/job_apply_wizard_form');
require('./pages/account/edit-profile');
require('./pages/account/edit-company-profile');
require('./pages/account/change-password');
require('./pages/account/delete-account');
require('./pages/account/delete-company-profile');
require('./pages/account/jobs');
require('./pages/account/job-closing-reasons');
require('./pages/account/billing-information');
require('./pages/account/products');
require('./pages/account/view-resume');
require('./pages/account/employer-user-invitations');
require('./pages/account/team-members');
require('./pages/account/notifications');
require('./pages/products');
require('./pages/job_seeker_account/profile');
require('./pages/job_seeker_account/blocked_employers');
require('./pages/job_seeker_account/registration_page');
require('./pages/job_seeker_account/job_seeker_registration_wizard_form');
require('./pages/forgotPasswordForm');
require('./pages/billing');
